import React, { Component } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import { About } from './components/About';
import { NotFound } from './components/NotFound';
import { Privacy } from './components/Privacy';
import { ContextProvider } from './globalState/state';

class App extends Component {
  render() {
    return (
      <ContextProvider>
        <Router>
          <Routes>
            <Route path='/' element={<About />} />
            <Route path='/privacy' element={<Privacy />} />
            <Route path='*' element={<NotFound />} />
          </Routes>
        </Router>
      </ContextProvider>
    );
  }
}

export default App;
